import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiEdit } from "react-icons/fi";
import Switch from "react-switch";
import { backendApi } from "../../api/apiService";

function CandidateStatus() {
  const [checked, setChecked] = useState(false);
  const [addCandidatePopup, setAddCandidatePopup] = useState(false);
  const [EditCandidatePopup, setEditCandidatePopup] = useState(false);
  const [EditCandidateid, setEditCandidateid] = useState("");
  const [StatusidToggle, setStatusidToggle] = useState("");
  const [statusName, setStatusName] = useState("");
  const [PointValue, setPointValue] = useState("");

  const [editstatusName, setEditStatusName] = useState("");
  const [status, setStatus] = useState([]);
  const [editPointValue, seteditPointValue] = useState("");
  const [Isdefault, setIsdefault] = useState("");

  const [togglestatus, setToggleStatus] = useState('');


  const handleChange = (event, status) => {
    console.log('eventeventevent', event);
    console.log('statusstatusstatus', status);
    // setStatus(
    //   status.map((obj) => {
    //     if (status.id === obj.id) {
    //       return {
    //         ...obj,
    //         is_active: event === true ? 1 : 0,
    //       };
    //     }
    //     return obj;
    //   })
    // );
    var req = {
      functionName: "activeDeactiveCandidateStatus",
      id: status.id,
      is_active: event,
    };
    console.log('activeDeactiveCandidateStatus', req);
    backendApi(req).then((response) => {
      if (response.success == 1) {
        toast.success("Status Changed successsfully", { containerId: "F" });
        getAllStatus();
      }
      else {
        console.log("error while fetching openings");
        return false;
      }
    });
  };




  // const handleChange = () => { 
  //   console.log('staus........',togglestatus);
  //   var req = {
  //     functionName: "activeDeactiveCandidateStatus",
  //     is_active:togglestatus,
  //     id:StatusidToggle,
  //   };
  //   console.log("req", req);
  //   backendApi(req).then((response) => {
  //     console.log('Status Toggle',response);
  //     if (response.success == 1) {
  //       setChecked(togglestatus);
  //       getAllStatus();

  //     } else {
  //       console.log("Error in status viewing.");
  //       return false;
  //     }
  //   });
  // };
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("candidatestatusMenu")?.classList?.add("active");
    }, 500);
    getAllStatus();
  }, []);

  const getAllStatus = () => {
    var req = {
      functionName: "listCandidateStatus",
      site_id: localStorage.getItem("siteId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log('Status Results', response);
      if (response.success == 1) {
        setStatus(response.dataSet)
      } else {
        console.log("Error in status viewing.");
        return false;
      }
    });
  };
  const Cancel = () => {
    setAddCandidatePopup(false);
  };
  const CancelEdit = () => {
    setEditCandidatePopup(false);
  };
  const Save = () => {
    if (statusName.trim() === "") {
      toast.warn("Please enter an Status Name:", { containerId: "F" });
      return false;
    }
    if (statusName.length > 0) {
      var req = {
        functionName: "saveCandidateStatus",
        site_id: localStorage.getItem("siteId"),
        status_name: statusName,
        point_value: PointValue
      };
      console.log("Savingggggggg", req);
      backendApi(req).then((response) => {
        console.log(response);
        if (response.success == 1) {
          toast.success("Status Saved successsfully", { containerId: "F" });
          setAddCandidatePopup(false);
          setStatusName("");
          getAllStatus();
        } else {
          toast.warn("Error Saving status.", { containerId: "F" });
          return false;
        }
      });
    } else {
      toast.warn(
        "Error in Status Creation.",
        { containerId: "F" }
      );
      return false;
    }
  };
  const Update = () => {
    if (editstatusName.trim() === "") {
      toast.warn("Please enter an Status Name:", { containerId: "F" });
      return false;
    }
    if (editstatusName.length > 0) {
      var req = {
        functionName: "updateCandidateStatus",
        id: EditCandidateid,
        status_name: editstatusName,
        point_value: editPointValue
      };
      console.log("updatinggggg", req);
      backendApi(req).then((response) => {
        console.log(response);
        if (response.success == 1) {
          toast.success("Status Updated successsfully", { containerId: "F" });
          setEditCandidatePopup(false);
          setEditStatusName("");
          getAllStatus();
        } else {
          toast.warn("Error Saving status.", { containerId: "F" });
          return false;
        }
      });
    } else {
      toast.warn(
        "Error in Status Creation.",
        { containerId: "F" }
      );
      return false;
    }
  };

  const [menuClick, setMenuClick] = useState(false)
  const toggleMenu = () => {
    setMenuClick(!menuClick)
  }
  const closeMenu = () => {
    setMenuClick(false)
  }
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>


        <ToastContainer
          enableMultiContainer
          containerId={"F"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header Header="Candidate Status" toggleMenu={toggleMenu} menuClick={menuClick} />
          <div className="main-container">

            <div className="xilliRight">
              <div className="xilliWrap">
                <div className="card main-card">
                  <div className="card-body m-auto col-lg-9">
                    <div className="xilliBrudcrb">
                      <div className="text-end mb-3">
                        <button className="btn-btn btn btn-btn2 btn-sm"
                          onClick={() => setAddCandidatePopup(true)}>Add New</button>

                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="xilliWrap table-wrap">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Sl.No</th>
                                    <th>Name</th>
                                    <th>Points</th>
                                    <th>Action</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {status.map((status, index) => (
                                    <tr>
                                      <td aria-label="Sl.No">{index + 1}</td>
                                      <td aria-label="Title">{status.status_name}</td>
                                      <td aria-label="Title">{status.point_value}</td>
                                      <td aria-label="Action"><FiEdit className="text-primary"
                                        onClick={() => {
                                          setEditCandidateid(status.id);
                                          setEditStatusName(status.status_name);
                                          seteditPointValue(status.point_value);
                                          setIsdefault(status.is_default);
                                          setEditCandidatePopup(true);
                                        }}
                                      /></td>
                                      <td aria-label={status.id}>
                                        <Switch
                                          checked={
                                            status.is_active === 1
                                              ? true
                                              : false
                                          }
                                          onChange={(checked) => {
                                            handleChange(
                                              checked,
                                              status
                                            );
                                          }}
                                          width={40} height={18} /></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {addCandidatePopup && (
            <div className="modal_parent">
              <div className="module_popup addPeople bfAddPeople shadow-lg">
                <div className="module_innerpopup module_bodypop">
                  <div className="module_headdiv">
                    <h4 className="popup_head">Add New Status</h4>
                  </div>
                  <div className="module_body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="input-group input-group-outline my-2 location_search">
                          <label htmlFor="" className="form-label">
                            Status Name
                          </label>
                          <div className="col-md-12 p-0 position-relative">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Status Name..."
                              value={statusName}
                              onChange={(e) => setStatusName(e.target.value)}
                            />
                          </div>
                        </div>{" "}

                        <div className="input-group input-group-outline my-2 location_search">
                          <label htmlFor="" className="form-label">
                            Point Value
                          </label>
                          <div className="col-md-12 p-0 position-relative">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Point Value..."
                              value={PointValue}
                              onChange={(e) => setPointValue(e.target.value)}
                            />
                          </div>
                        </div>{" "}


                      </div>

                    </div>
                  </div>

                  <div className="childIssueses my-2">
                    <button className="btn-btn btn btn-btn1 me-2 btn-sm" onClick={Save}>
                      Add
                    </button>
                    <button
                      className="btn-btn btn btn-btn2 btn-sm"
                      onClick={() => {
                        Cancel();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {EditCandidatePopup && (
            <div className="modal_parent">
              <div className="module_popup addPeople bfAddPeople shadow-lg">
                <div className="module_innerpopup module_bodypop">
                  <div className="module_headdiv">
                    <h4 className="popup_head">Edit Status</h4>
                  </div>
                  <div className="module_body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="input-group input-group-outline my-2 location_search">
                          <label htmlFor="" className="form-label">
                            Status Name
                          </label>
                          <div className="col-md-12 p-0 position-relative">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Status Name..."
                              value={editstatusName}
                              readOnly={Isdefault === 1}
                              style={{
                                backgroundColor: Isdefault === 1 ? "#f0f0f0" : "#fff",
                              }}
                              onChange={(e) => setEditStatusName(e.target.value)}
                            />

                          </div>
                        </div>{" "}
                        <div className="input-group input-group-outline my-2 location_search">
                          <label htmlFor="" className="form-label">
                            Point Value
                          </label>
                          <div className="col-md-12 p-0 position-relative">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter  Point Value..."
                              value={editPointValue}
                              onChange={(e) => seteditPointValue(e.target.value)}
                            />
                          </div>
                        </div>{" "}
                      </div>

                    </div>
                  </div>

                  <div className="childIssueses my-2">
                    <button className="btn-btn btn btn-btn1 me-2" onClick={Update}>
                      Update
                    </button>
                    <button
                      className="btn-btn btn btn-btn2"
                      onClick={() => {
                        CancelEdit();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default CandidateStatus;
